module.exports = __webpack_public_path__ + "img/Gärtnerinnen.a20a7e31.jpg";